export const isSpecialType  = (questionKey?: string | null, answerKeysData?: string[], answerIdsData?: string[]) : boolean => {
  const answerIds = [...answerIdsData || []];
  const answerKeys = [...answerKeysData || []];
  const firstId = answerIds[0] || undefined;
  const firstKey = answerKeys[0] || undefined;
  const specialType = !!firstId && !!firstKey && firstKey === firstId && questionKey !== undefined &&
    (['videocallCompanyRegionsCheck', 'phoneCompanyRegionsCheck','phoneLanguage','videocallLanguage'].includes(questionKey));
  return specialType;
};